import axios from 'axios'
import Qs from 'qs'
import store from '../store'

const setShowLoading = (bool)=> {
    store.dispatch({type:'setShowLoading',value:bool})
}

const request = axios.create({
    // API 
     baseURL: 'https://api.xiehe.shop/web/',
   //baseURL: 'http://localhost:9098/web/',
    //baseURL: 'https://themisfinance.com/api/public/index.php/',
    //baseURL: 'http://admin.tfccoin.cc/api/public/index.php/',
    //baseURL: 'https://tfcdao.com/api/public/index.php/',
    timeout: 60000 // 
  })

// 异常拦截处理器
const errorHandler = (error) => {
    setShowLoading(false)
   
    if (error.response) {
      const data = error.response.data
  
      
      
    //   const token = window.acToken
      if (error.response.status === 403) {
          this.$message.error(data.message);
      }
      // if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      //   notification.error({
      //     message: 'Unauthorized',
      //     description: 'Authorization verification failed'
      //   })
      //   if (token) {
      //     store.dispatch('Logout').then(() => {
      //       setTimeout(() => {
      //         window.location.reload()
      //       }, 1500)
      //     })
      //   }
      // }
    }
    return Promise.reject(error)
  }

  // request interceptor
request.interceptors.request.use(config => {
  
    if(!config.data.closeLoading){
      
      setShowLoading(true)
    }
    
    const token = window.pass 
    
    if (token) {
      config.headers['TOKEN'] = token 
    }

    
   
      if (config.method === 'post' && config.data === undefined  ) {
        // config.data={
        //   pass:window.pass 
        // }
       
      
        config.data = Qs.stringify(config.data)
      }
     
      
    
  
    return config
  }, errorHandler)

  // response interceptor
request.interceptors.response.use((response) => {
    setShowLoading(false)
    return response.data
  }, errorHandler)

  export default request